// paper.js does the path booleans for exports. It's large, so it only loads when the
// studio first exports something; the server serves it from node_modules
let loading = null

export default function loadPaper() {
	if (!loading) {
		loading = new Promise((resolve, reject) => {
			const ready = () => {
				const paper = window.paper
				paper.setup(new paper.Size(24, 24))
				resolve(paper)
			}
			if (window.paper) return ready()
			const script = document.createElement('script')
			script.src = '/vendor/paper-core.min.js'
			script.async = true
			script.onload = ready
			script.onerror = () => {
				loading = null
				reject(new Error('Could not load the path tools'))
			}
			document.head.appendChild(script)
		})
	}
	return loading
}
